var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCoinsSwap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 7.0272C10.2572 5.53652 11.064 4.19646 12.2611 3.27169C13.4582 2.34693 14.9586 1.90468 16.4659 2.0323C17.9732 2.15992 19.3779 2.84813 20.4025 3.961C21.4271 5.07387 21.9971 6.5305 22 8.0432C21.9998 9.46969 21.4951 10.8501 20.5751 11.9403C19.6551 13.0305 18.3792 13.7602 16.973 14.0002M2 9.0002C2 5.6832 4.683 3.0002 8 3.0002L7.143 4.7142M22 15.0002C22 18.3172 19.317 21.0002 16 21.0002L16.857 19.2862M8 22.0002C9.5913 22.0002 11.1174 21.3681 12.2426 20.2428C13.3679 19.1176 14 17.5915 14 16.0002C14 14.4089 13.3679 12.8828 12.2426 11.7576C11.1174 10.6323 9.5913 10.0002 8 10.0002C6.4087 10.0002 4.88258 10.6323 3.75736 11.7576C2.63214 12.8828 2 14.4089 2 16.0002C2 17.5915 2.63214 19.1176 3.75736 20.2428C4.88258 21.3681 6.4087 22.0002 8 22.0002Z",
    stroke: "#0986E6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsSwap);
export default __webpack_public_path__ + "static/media/coins_swap.430b14bbdb30d0f78d3cf021a4cc28af.svg";
export { ForwardRef as ReactComponent };